import styled from "styled-components";
import { BLUE_RIBBON_700, GRAYSCALE_200 } from "../../styles/colors";
import { INTER } from "../../styles/fonts";

export const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const ButtonTouchable = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
`;

export const GradientBorder = styled.div`
    width: 53.5px;
    height: 53.5px;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.75;
    background: linear-gradient(180deg, ${GRAYSCALE_200} 0%, #b9afffff 100%);
`;

export const IconWrapper = styled.div`
    width: 52px;
    height: 52px;
    border-radius: 27px;
    background-color: #ffffffbf;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 80%;
`;

export const ButtonTitle = styled.span`
    margin-top: 8px;
    font-size: 12px;
    color: ${BLUE_RIBBON_700};
    font-weight: 400;
    font-family: ${INTER.regular};
    text-align: center;
`;
